const items = [
  "The Sacred Wild",
  "New York",
  "Framing Flowers",
  "Nairobi",
  "An Intimate Affair",
  "Dubai",
  "Spirit & Silence",
  "Seoul",
  "Lalit Kala Akademi",
  "Zurich",
];

export default function Marquee() {
  const loop = [...items, ...items];
  return (
    <section
      className="border-y border-ink-soft/15 bg-sand py-6 marquee-mask overflow-hidden"
      aria-label="Exhibitions"
      data-testid="marquee"
    >
      <div className="marquee-track">
        {loop.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl text-ink-soft px-8">
              {it}
            </span>
            <span className="text-ochre text-lg">&#10022;</span>
          </span>
        ))}
      </div>
    </section>
  );
}
